<template>
  <cv-content id="main-content" style="width: 100vw;">
    <cv-data-table :columns="colonne"
                   :data="righe"
                   title="Comuni"
                   helper-text="Elenco dei Comuni Italiani" />
  </cv-content>
</template>

<script>
export default {
  name: "Comuni",
  data: function() {
    return {
      colonne: [
          "Descrizione",
          "Provincia",
          "CAP"
      ],
      righe: [
        [
          "Ferrara", "FE", "44121"
        ],
        [
          "Fusignano", "RA", "48034"
        ],
        [
          "Rovereto", "TN", "38068"
        ],
        [
          "Russi", "RA", "48026"
        ],

      ]
    }
  }
}
</script>

<style scoped>

</style>